import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_PRODUCT_CATEGORY_LIST_REQUEST,
  ADD_PRODUCT_CATEGORY_REQUEST,
  UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
  UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_REQUEST,
  DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
} from "./actionTypes";
import {
  updateProductCategoryStatusByProductCategoryIdResponse,
  getProductCategoryListResponse,
  addProductCategoryResponse,
  updateProductCategoryByProductCategoryIdResponse,
  deleteProductCategoryByProductCategoryIdResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getProductCategoryList() {
  try {
    const response = yield call(invokeApi, "get", "/ProductCategory", "");
    yield put(getProductCategoryListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* addProductCategory({ payload: { data } }) {
  try {
    const response = yield call(invokeApi, "post", "/ProductCategory", data);
    // if (response.isSuccessResponse) {
    //     yield put(getProductCategoryListRequest());
    // }
    yield put(addProductCategoryResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductCategoryByProductCategoryId({
  payload: { productCategoryId, data },
}) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/ProductCategory/" + productCategoryId,
      data
    );
    yield put(updateProductCategoryByProductCategoryIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* deleteProductCategoryByProductCategoryId({
  payload: { productCategoryId },
}) {
  try {
    const response = yield call(
      invokeApi,
      "delete",
      "/ProductCategory/" + productCategoryId
    );
    yield put(deleteProductCategoryByProductCategoryIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductCategoryStatusByProductCategoryId({
  payload: { productCategoryId, status },
}) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/ProductCategory/" + productCategoryId + "/" + status
    );
    yield put(updateProductCategoryStatusByProductCategoryIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchProductCategoryMaster() {
  yield takeEvery(GET_PRODUCT_CATEGORY_LIST_REQUEST, getProductCategoryList);
  yield takeEvery(ADD_PRODUCT_CATEGORY_REQUEST, addProductCategory);
  yield takeEvery(
    UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
    updateProductCategoryByProductCategoryId
  );
  yield takeEvery(
    DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST,
    deleteProductCategoryByProductCategoryId
  );
  yield takeEvery(
    UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_REQUEST,
    updateProductCategoryStatusByProductCategoryId
  );
}

function* productCategoryMasterSaga() {
  yield all([fork(watchProductCategoryMaster)]);
}

export default productCategoryMasterSaga;
